import DiscordIcon from './DiscordIcon/DiscordIcon';

export const socialIcons: SocialIconsInterface = {
	discord: DiscordIcon,
};

export interface SocialIconsInterface {
	discord: React.FC<React.SVGProps<SVGSVGElement>>;
}
